import {lighten} from 'polished';
import styled, {css} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {colors} from 'theme';

export const UserStatusTag = styled.div<{isActive: boolean}>`
    padding: 7px 10px;
    font-size: 11px;
    font-weight: 500;
    border-radius: 4px;
    color: ${(p) => (p.isActive ? colors.success : colors.danger)};
    background-color: ${(p) =>
        p.isActive ? lighten(0.36, colors.success) : lighten(0.25, colors.danger)};
    cursor: default;
    white-space: nowrap;
`;

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: center;
    min-width: 60px;
    gap: 10px;
`;

export const Action = styled.div<{disabled?: boolean}>`
    padding: 5px;
    cursor: pointer;
    ${(props) =>
        props.disabled &&
        css`
            pointer-events: none;
            opacity: 0.3;
        `}
`;

export const CreateUserButton = styled(Button)`
    width: auto;
`;

export const HeaderControls = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export const EmployeeNameButton = styled.button`
    padding: 0;
    border: 0;
    background: transparent;
    color: ${colors.brandPrimary};
    font: inherit;
    text-align: left;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

export const ConfirmRemoveFooter = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const CancelConfirmButton = styled(Button)`
    border: 1px solid ${colors.danger} !important;
    color: ${colors.danger};
`;

export const SubmitConfirmButton = styled(Button)`
    background-color: ${colors.danger} !important;
    border: 1px solid ${colors.danger} !important;
`;
